// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__GhVkj","actions":"GroupTable_actions__7a6bR","deleteModalFooter":"GroupTable_deleteModalFooter__3fSbv"};